<div
  [ngStyle]="
    data.history ? { 'max-height': '60vh', 'overflow-y': 'scroll', padding: '15px 10px' } : {}
  "
>
  <div *ngIf="loadingHistory" class="card-body-progress d-flex justify-content-center p-2">
    <mat-spinner [diameter]="20"></mat-spinner>
  </div>
  <div *ngIf="!(loadingHistory || history.length)" class="d-flex flex-column text-center w-100">
    <span class="font-size-lg font-weight-bold">No Actions!</span>
    <span>Your actions will be displayed here.</span>
  </div>
  <div *ngIf="!loadingHistory && history.length">
    <div
      *ngFor="let record of history"
      class="hoverable cursor-pointer d-flex p-2"
      (click)="openDialog($event, record)"
    >
      <kt-user-photo
        [size]="40"
        [type]="'object'"
        [editable]="false"
        [user$]="record"
      ></kt-user-photo>
      <div class="d-flex flex-column justify-content-center w-100 ml-3">
        <div class="d-flex align-items-center justify-content-between">
          <div class="text-dark-75 font-size-md overflow-hidden">
            <span class="font-weight-bold mr-3">{{ record.username }}</span>
            <span class="text-muted mr-2">{{ record.isComment ? 'comment' : 'workflow' }}</span>
            <span>"{{ getHistoryText(record) }}"</span>
          </div>
          <div
            class="label label-inline"
            [ngClass]="{
              'label-light-success': record.rev_type === 'ADD',
              'label-light-warning': record.rev_type === 'MOD',
              'label-light-danger': record.rev_type === 'DEL'
            }"
          >
            {{
              record.rev_type === 'ADD'
                ? 'Created'
                : record.rev_type === 'MOD'
                ? 'Modified'
                : 'Deleted'
            }}
          </div>
        </div>
        <span class="text-muted font-weight-normal font-size-xs">{{
          getFormattedDate(record.rev_timestamp)
        }}</span>
      </div>
    </div>
  </div>
</div>
